module.exports = __webpack_public_path__ + "img/email-clients.627a0c39.svg";